import { useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import theme from "assets/theme";
import Presentation from "layouts/pages/presentation";

import routes from "routes";
import FloatingActions from "pages/Presentation/sections/FloatingButtons";
import AppGlobalStyles from "styles/GlobalStyles";
import TermsAndConditions from "pages/LandingPages/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "pages/LandingPages/Privacy/PrivacyPolicy";
import RefundPolicy from "pages/LandingPages/RefundPolicy/RefundPolicy";
import SignInBasic from "pages/LandingPages/SignIn";
import "./App.css";
import SearchArtists from "pages/LandingPages/SearchArtists/SearchArtists";

export default function App() {
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <AppGlobalStyles />
      <CssBaseline />
      <Routes>
        {getRoutes(routes)}
        <Route path="/home" element={<Presentation />} />
        <Route path="/search-artists" element={<SearchArtists/>}/>
        <Route path="/terms-and-conditions" element={<TermsAndConditions/>}/>
        <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
        <Route path="/refund-policy" element={<RefundPolicy/>}/>
        <Route path="/authentication/sign-in" element={<SignInBasic/>}/>
        <Route path="*" element={<Navigate to="/home" />} />
      </Routes>
      <FloatingActions />
    </ThemeProvider>
  );
}
